import { candidateDetailsReducer } from './candidate_details_reducer';
import { tabReducer } from './layout_reducer';
import { notesReducer } from './notes_reducer';
import { activityFeedReducer } from './activity_feed_reducer';
import { offersReducer } from './offers_reducer';
import { documentReducer } from './document_reducer';
import { statusReducer } from './status_reducer';
import { agreementsReducer } from './agreements_reducer';
import { scorecardReducer } from './scorecard_reducer';

const allReducers = {
  tabReducer,
  notesReducer,
  candidateDetailsReducer,
  activityFeedReducer,
  offersReducer,
  documentReducer,
  statusReducer,
  agreementsReducer,
  scorecardReducer,
} as const;

export default allReducers;
